import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SegmentedControlOption<T = string> {
  label: string;
  value: T;
  disabled?: boolean;
}

export const POS_PAGE_SIZE_OPTIONS: SegmentedControlOption[] = [
  { label: 'A4', value: 'A4' },
  { label: 'Thermal', value: 'THERMAL' },
];

@Component({
  selector: 'hospitality-bot-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrls: ['./segmented-control.component.scss'],
})
export class SegmentedControlComponent<T = string> {
  @Input() label = '';
  @Input() options: SegmentedControlOption<T>[] = [];
  @Input() value: T;
  @Input() disabled = false;
  @Input() size: 'sm' | 'md' = 'sm';

  @Output() valueChange = new EventEmitter<T>();
  @Output() onChange = new EventEmitter<T>();

  select(option: SegmentedControlOption<T>): void {
    if (this.disabled || option.disabled || this.value === option.value) {
      return;
    }
    this.value = option.value;
    this.valueChange.emit(option.value);
    this.onChange.emit(option.value);
  }

  trackByValue(_: number, option: SegmentedControlOption<T>): T {
    return option.value;
  }
}
